import { axiosBase } from 'utils';

const axios = axiosBase.create();

export function apiKeysListService() {
  return axios.get('/apikeys');
}

export function apiKeysCreateService(data) {
  return axios.post('/apikeys', data);
}

export function apiKeysDeleteService(id) {
  return axios.delete(`/apikeys/${id}`);
}

export function apiKeysToggleActiveService(id, isActive) {
  return axios.patch(`/apikeys/${id}`, { is_active: isActive });
}

export function apiKeysUpdateService(id, data) {
  return axios.patch(`/apikeys/${id}`, data);
}

export function apiKeysGetByIdService(id) {
  return axios.get(`/apikeys/${id}`);
}
